import Glide from '@glidejs/glide';
import ScrollOut from 'scroll-out';
import '@dotlottie/player-component';
document.addEventListener("DOMContentLoaded", function () {
  stickyHeader();
  newsSlider();
});

function stickyHeader() {
  const header = document.querySelector("#masthead");
  const scrollUp = "sticky";
  const scrollDown = "sticky-up";
  let lastScroll = 0;
  let communityFormScroll = document.querySelector(".community-form");

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 50) {
      header.classList.remove(scrollUp);
      header.classList.remove("dark");
      header.classList.remove(scrollDown);
      return;
    }

    if (currentScroll > lastScroll && !header.classList.contains(scrollDown)) {
      // down
      header.classList.remove(scrollUp);
      header.classList.remove("dark");
      header.classList.add(scrollDown);
      if (communityFormScroll) {
        communityFormScroll.style.top = header.offsetHeight + 12 + "px";
      }
    } else if (
      currentScroll < lastScroll &&
      header.classList.contains(scrollDown)
    ) {
      // up
      header.classList.remove(scrollDown);
      header.classList.add(scrollUp);
      header.classList.add("dark");
      if (communityFormScroll) {
        communityFormScroll.style.top = 0 + "px";
      }
    }
    lastScroll = currentScroll;
  });
}

// News posts slider
function newsSlider() {
  let sliders = document.querySelectorAll(".news-slider__wrapper");
  sliders.forEach((sliderElement) => {
    let slider = new Glide(sliderElement, {
      type: "slider",
      startAt: 0,
      perView: 2,
      gap: 24,
      focusAt: 0,
      rewind: false,
      breakpoints: {
        767: {
          perView: 1,
        },
      },
    });

    slider.mount();
  });
}

jQuery(document).ready(function ($) {
  "use strict";
  /**
   * Scroll to next section
   */
  $(document).on('click', '.js-scroll-down', function () {
    let nextSection = $(this).parent().parent().next();
    let headerOffset = window.innerWidth < 1200 ? getComputedStyle(document.documentElement).getPropertyValue('--header-height') : getComputedStyle(document.documentElement).getPropertyValue('--mobile-header-height');
    headerOffset = parseFloat(headerOffset) ? parseFloat(headerOffset) : $('.site-header__inner').height();
    if (nextSection.length) {
      $('html, body').animate({scrollTop: nextSection.offset().top - headerOffset}, 0);
    }
  });

  $('.cases__filter-items').on('click', function(){
    $('.cases__filter-items.active').not(this).removeClass('active');
    $(this).toggleClass('active');
  });
  $('.cases__filter-list span').on('click', function(){
    if( $(this).hasClass('active') ){
      $('.cases__selection-item[data-id=' + $(this).data('id') + ']').remove();
    }else{
      $('<div class="cases__selection-item" data-id="' + $(this).data('id') + '"><span class="name">' + $(this).parent().data('name') + ':</span> ' + $(this).text() + '<span class="close"></span></div>').appendTo('.cases__selection')
    }
    $(this).toggleClass('active');
    if( $('.cases__filter-list span.active').length ){
      $('.reset_filters').show();
    }else{
      $('.reset_filters').hide();
    }
    load_cases(0, false);
  });
  $('.reset_filters').on('click', function(){
    $(this).hide();
    $('.cases__filter-list span').each(function(){
      $(this).removeClass('active');
    })
    $('.cases__selection-item').remove();
    load_cases(0, false);
  })
  $('.cases__title').on('click','.cases__selection-item .close', function(){
    $('.cases__filter-list span[data-id=' + $(this).parent().data('id') + ']').removeClass('active');
    $(this).parent().remove();
    load_cases(0, false);
  })
  if($('.cases__filter').length ){
    $(document).click(function(event) {
      if (!$(event.target).closest(".cases__filter-items").length ) {
        $('.cases__filter-items.active').removeClass('active');
      }
    });
  }

  function load_cases(offset = 0, button){
    let industry = [];
    let service = [];
    let technology = [];
    let per_page = 4;
    let body = $('.blog_posts');
    let button_more = $('.js-load-more');
    $('.cases__filter-list[data-name=Industry] span.active').each(function(){
      industry.push( $(this).data('id') );
    })
    $('.cases__filter-list[data-name=Service] span.active').each(function(){
      service.push( $(this).data('id') );
    })
    $('.cases__filter-list[data-name=Technology] span.active').each(function(){
      technology.push( $(this).data('id') );
    })
    let data = {
      action: 'load_cases',
      industry: industry,
      service: service,
      technology: technology,
      offset: offset,
      per_page: per_page
    };
    $.ajax({
      url: wpApiSettings.ajaxUrl,
      type: 'POST',
      data: data,
      success: (response) => {
        if( ! response.data.button ){
          button_more.hide();
        }else{
          button_more.show();
        }
        body.html(response.data.content);
        offset = offset + per_page;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }
  /**
   * Counter.
   */
  let countertScrollOut = ScrollOut({
    once: true,
    onShown: function (element, ctx, scrollingElement) {
      if ($(element).hasClass('js-counter')) {
        let counterNumber = $(element);
        if (counterNumber.length) {
          counterNumber.each(function () {
            $(this).prop('Counter', 0).animate({
              Counter: $(this).data('counter')
            }, {
              duration: 3000,
              easing: 'swing',
              step: function (now) {
                $(this).text(Math.ceil(now));
              }
            });
          });
        }
      }
    }
  });
  $(window).on('load', function () {
    if (countertScrollOut) countertScrollOut.update();
  });

  const scrollOut = ScrollOut({
    offset: 0,
    threshold: 0.01,
    once: true,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        let timer = $(element).css('transition-delay');
        if (timer) {
          window.setTimeout(function () {
            $(element).find('.ease-order__item').each(function (i) {
              let $this = $(this);
              $(this).attr('data-scroll', '');
              window.setTimeout(function () {
                $this.attr('data-scroll', 'in');
              }, 200 * i);
            });
          }, parseFloat(timer) * 1000);
        }
      }
    }
  });
  if( $('.solve-problems').length && $(window).width() > 1255 ){
    if( $(window).scrollTop() < 50 ){
      $('.site-header').addClass('dark').addClass('no_border');
    }
    if ( $(window).scrollTop() < ( $('.solve-problems').height() - jQuery('.solve-problems__lottie-face').innerHeight() ) ) {
      $('.site-content').addClass('dark');
    }
    $(window).on('scroll', function () {
      let scroll_page = false,
      scroll_header = false;
      let window_scroll = $(window).scrollTop();
      if ( window_scroll > ( $('.solve-problems').height() - jQuery('.solve-problems__lottie-face').innerHeight() ) ) {
          if( ! scroll_page ){
            $('.solve-problems').removeClass('dark');
            $('.site-content').removeClass('dark');
            scroll_page = true;
          }
      } else {
        $('.solve-problems').addClass('dark');
        $('.site-content').addClass('dark');
        scroll_page = false;
      }
      if ( window_scroll > 50 ) {
        if( ! scroll_header ){
          if( $('.site-header').hasClass('no_border') ){
            $('.site-header').removeClass('dark').removeClass('no_border');
          }
          scroll_header = true;
        }
      } else {
        scroll_header = false;
        $('.site-header').addClass('dark').addClass('no_border');
      }
    });
  }
});